import { useEffect, useState } from "react";
import operatorApiService from "../../../services/operator-api.service";
import UserCreateModal from "./modal/UserCreateModal";
import UserEditModal from "./modal/UserEditModal";
import "../CommonDesign.scss";
import editIcon from "../../../assets/imgs/master/edit_icon_wh.svg";
import deleteIcon from "../../../assets/imgs/master/delete_icon_wh.svg";

interface RoleUser {
  user_id: number;
  role_cd: string;
  monitor_console_id: number | null;
  user_name: string;
  communication_code: string;
  status: "original" | "edited" | "deleted";
  isEditing?: boolean;
}

const User = () => {
  const [rows, setRows] = useState<RoleUser[]>([]);
  const [searchUserName, setSearchUserName] = useState<string>("");
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [editTarget, setEditTarget] = useState<RoleUser | null>(null);

  const fetchUsers = async () => {
    const userList = await operatorApiService.doGetUsers({
      searchUserName,
    });
    setRows(userList);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleSearch = async () => {
    fetchUsers();
  };

  const handleEditClick = (user: RoleUser) => {
    setEditTarget(user);
  };

  useEffect(() => {
    if (editTarget !== null) {
      setIsEditModalOpen(true);
    }
  }, [editTarget]);

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setEditTarget(null);
  };

  const handleDelete = async (userId: number) => {
    const confirmed = window.confirm("このユーザを削除してよろしいですか？");
    if (!confirmed) return;

    try {
      await operatorApiService.deleteUser(userId).then((response) => {
        if (response.status === "success") {
          setSuccessMessage("削除に成功しました。");
          setTimeout(() => setSuccessMessage(null), 3000);
        }
      });
      fetchUsers();
    } catch (error) {
      setErrorMessage("削除に失敗しました。");
      setTimeout(() => setErrorMessage(null), 3000);
    }
  };

  return (
    <div className="user">
      <div className="content">
        <div className="title">ユーザ</div>
        <div className="section">
          <div className="sectionTitle">検索条件</div>
          <div className="sectionBody">
            <div className="searchArea">
              <div className="searchLine">
                <div>ユーザ名</div>
                <input
                  value={searchUserName}
                  onChange={(e) => setSearchUserName(e.target.value)}
                />
              </div>
              <button className="searchButton" onClick={handleSearch}>
                検索
              </button>
            </div>
          </div>
        </div>
        <div className="section">
          <div className="sectionTitle">検索結果</div>
          <div className="sectionBody">
            <button
              className="createUserButton"
              onClick={() => setIsCreateModalOpen(true)}
            >
              新規登録
            </button>
            <table className="tableArea">
              <thead>
                <tr>
                  <th>ユーザID</th>
                  <th>権限CD</th>
                  <th>監視卓ID</th>
                  <th>ユーザー名</th>
                  <th>通信識別コード</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((user) => (
                  <tr key={user.user_id}>
                    <td>{user.user_id}</td>
                    <td>{user.role_cd}</td>
                    <td>{user.monitor_console_id ?? ""}</td>
                    <td>{user.user_name}</td>
                    <td>{user.communication_code}</td>
                    <td>
                      <div className="buttonGroup">
                        <button
                          className="updateButton"
                          onClick={() => handleEditClick(user)}
                        >
                          <img src={editIcon} alt="" className="icon" />
                          編集
                        </button>
                        <button
                          className="deleteButton"
                          onClick={() => handleDelete(user.user_id)}
                        >
                          <img src={deleteIcon} alt="" className="icon" />
                          削除
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {successMessage && (
              <div className="successMessage">{successMessage}</div>
            )}
            {errorMessage && <div className="errorMessage">{errorMessage}</div>}
          </div>
        </div>
        <UserCreateModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
          onSuccess={fetchUsers}
        />
        <UserEditModal
          isOpen={isEditModalOpen}
          onClose={handleCloseEditModal}
          onSuccess={fetchUsers}
          editTarget={editTarget}
        />
      </div>
    </div>
  );
};

export default User;
